import styled from '@emotion/styled';

export const CardTitle = styled.div({
  width: '100%',
  padding: '14px 0',
});
